import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrossThin = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 43 43",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m4.977.744.144.135 16.379 16.378 16.379-16.378a3 3 0 0 1 4.377 4.098l-.135.144-16.378 16.379 16.378 16.379a3 3 0 0 1 -4.098 4.377l-.144-.135-16.379-16.378-16.379 16.378a3 3 0 0 1 -4.377-4.098l.135-.144 16.378-16.379-16.378-16.379a3 3 0 0 1 4.098-4.377z" })
});
export default SvgCrossThin;
